import { valibotResolver } from "@hookform/resolvers/valibot";
import { PlusCircle } from "@phosphor-icons/react";
import { useState } from "react";
import { useForm } from "react-hook-form";

import {
  CouponCodeSchema,
  type CouponCodeSchemaType,
} from "features/subscriptions/schemes";

import DottedSeparator from "common/components/DottedSeparator";
import { Button } from "common/components/ui/Button";
import FormField from "common/components/ui/FormField";
import { Input } from "common/components/ui/Input";

export default function AddCoupon({
  setCouponId,
}: {
  setCouponId: (couponId: string) => void;
}) {
  const [isAdding, setIsAdding] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      code: "",
    },
    resolver: valibotResolver(CouponCodeSchema),
  });

  function onSubmit(data: CouponCodeSchemaType) {
    setCouponId(data.code);
    setIsAdding(false);
  }

  if (isAdding) {
    return (
      <FormField
        label="Add a coupon"
        htmlFor="coupon-code-input"
        className="px-1"
        size="sm"
        error={errors.code?.message}
      >
        <form className="flex gap-x-3" onSubmit={handleSubmit(onSubmit)}>
          <Input
            id="coupon-code-input"
            placeholder="Enter coupon code"
            variant="sm"
            className="flex-1"
            autoFocus
            {...register("code")}
          />
          <div className="gap-x-2 flex items-center">
            <Button
              size="sm"
              variant="secondary-black"
              onClick={() => setIsAdding(false)}
            >
              Cancel
            </Button>
            <Button size="sm" variant="secondary-purple" type="submit">
              Add
            </Button>
          </div>
        </form>
      </FormField>
    );
  }
  return (
    <>
      <DottedSeparator />
      <Button
        variant="link-purple"
        className="mr-auto ml-2.5"
        leftIcon={<PlusCircle weight="fill" />}
        onClick={() => setIsAdding(true)}
      >
        Add a coupon
      </Button>
      <DottedSeparator />
    </>
  );
}
